export default __webpack_public_path__ + "static/media/fb.3961822e.webp";